/*
 * Copyright (c) 2019 AccelByte Inc. All Rights Reserved
 * This is licensed software from AccelByte Inc, for limitations
 * and restrictions contact your company contract manager.
 */

import { isAxiosError } from "./errorDeducer";
import { isRight } from "fp-ts/lib/Either";
import { ServiceError } from "./types";

export function extractServiceErrorCode(error: Error): number | null {
  if (error && isAxiosError(error) && error.response && error.response.data) {
    const errorData = error.response.data;

    const ServiceErrorDecoder = ServiceError.decode(errorData);
    if (isRight(ServiceErrorDecoder)) return ServiceErrorDecoder.right.errorCode;
  }

  return null;
}
